import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable } from 'rxjs'
import { CanaryService } from '../services/canary.service'

@Injectable()
export class CanaryInterceptor implements HttpInterceptor {
  constructor(private canaryService: CanaryService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Add X-RCS-CANARY header to all requests
    const modifiedRequest = request.clone({
      setHeaders: {
        'X-RCS-CANARY': this.canaryService.isCanaryEnabled ? 'true' : 'false',
      },
    })

    return next.handle(modifiedRequest)
  }
}
